import {initFlatPickerInput} from "../../helpers/inputs/flatPicker/flatPicker";
import {createReplaceableElement} from "../../helpers/replaceableElement";
import createElement from "../../helpers/createElement";
import Axios from "axios";

/**
 * Initialize the public calendar index
 */
function initPublicCalendarIndex() {
    const calendarInput = document.querySelector('.calendar-dummy-input');
    const resultsContainer = document.querySelector('.calendar-events-results-list');

    if (!calendarInput || !resultsContainer) {
        return;
    }

    const refreshRoute = resultsContainer.dataset.refreshRoute;

    // Initialize replaceable element for results
    const replaceableResults = createReplaceableElement({
        element: resultsContainer,
        init: function () {
            // Any initialization for the new content can go here
        }
    });

    // Initialize flatpickr in inline mode
    const flatpickrInstance = initFlatPickerInput(calendarInput, {
        inline: true,
        mode: 'range',
        onChange: function (selectedDates, dateStr) {
            // Wait until a single date or a full range is selected
            if (selectedDates.length === 0) {
                return;
            }

            // Remove active class from all shortcut buttons on change, let the button add them back
            const shortcutButtons = document.querySelectorAll('.calendar-shortcuts-container button');
            shortcutButtons.forEach(b => b.classList.remove('active'));

            const data = {};
            if (selectedDates.length === 1) {
                data.date = dateStr;
            } else if (selectedDates.length === 2) {
                data.date_range = dateStr;
            }

            refreshResults(data);
        },
    });

    // Handle shortcuts
    const shortcutButtons = document.querySelectorAll('.calendar-shortcuts-container button');
    shortcutButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            const range = button.dataset.range;
            const startDate = new Date();
            let endDate = new Date();

            if (range === 'week') {
                // Set to current day and end of week (Saturday)
                const day = startDate.getDay();
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + (6 - day));
            } else if (range === 'month') {
                endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
            } else if (range === 'next30') {
                endDate = new Date(startDate);
                endDate.setDate(startDate.getDate() + 30);
            }

            // setDate(..., true) triggers onChange, which will clear the active class
            flatpickrInstance.setDate([startDate, endDate], true);

            // Re-add active class to this button
            button.classList.add('active');
        });
    });

    // Click first shortcut button if available (should be week button)
    if (shortcutButtons.item(0)) {
        shortcutButtons.item(0).click();
    }

    // Methods

    /**
     * Refresh the events list
     *
     * @param {Object} data
     */
    function refreshResults(data) {
        replaceableResults.startLoading();

        Axios.post(refreshRoute, data)
            .then(function (response) {
                const newElement = createElement(response.data.html);
                replaceableResults.replace(newElement);
            })
            .catch(function (error) {
                console.error('Error fetching events:', error);
                replaceableResults.stopLoading();
            });
    }
}

export {initPublicCalendarIndex}
